import { Component, OnInit } from "@angular/core";
import { DefaultPageComponent } from "../default-page.component";
import { BackNativeService } from "../../service/comunicator-native/back-native/back-native";
import { TokenService } from "../../service/token/token.service";
import { NavController } from "@ionic/angular";
import { JourneyService } from "../../service/journey/journey.service";
import { ReturnNativeService } from "../../service/comunicator-native/return-native/return-native";
import { DomainFactoryService } from "../../service/domains/domain-factory-service";
import { environment } from "../../../../environments/environment";
import { LogService } from "../../service/log/log.service";
import { formatDate } from "@angular/common";

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
})
export class SettingsComponent extends DefaultPageComponent implements OnInit {
  headerId = "settings";
  titlePage = "Parametrização";
  valueContaIonDomainOrigin = "Mock";
  valueContaIonDomainCityOrigin = "Mock";
  valueContaIonDataOrigin = "Mobile";
  logs = [];
  envInfo;
  caronteUrl;
  token;

  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    public logService: LogService,
    public domainFactory: DomainFactoryService,
    public tokenService: TokenService,
    public returnNativeService: ReturnNativeService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.valueContaIonDomainOrigin = environment.contaIonDomainOrigin;
    this.envInfo = environment.id;
    this.caronteUrl = environment.carontePix.initSessionUrl;
    tokenService.getToken().then((data) => {
      this.token = data;
    });
  }

  formatTime(data) {
    return formatDate(data, "dd/MM/YY HH:mm:ss:SSS", "pt-BR");
  }

  back() {
    this.router.back();
  }

  ionViewWillEnter() {
    this.logs = this.logService.getAll();
  }

  async ngOnInit() {}

  getPageId(): string {
    return this.headerId;
  }

  changeContaIonDomainOrigin(event) {
    environment.contaIonDomainOrigin = event.detail.value;
  }
}
